export default __webpack_public_path__ + "static/media/man-laptop.7e8f45cc.png";